
import React from "react";
import { Link, useLocation } from "react-router-dom";
import { Home, Database, Bell, ShoppingCart, Menu } from "lucide-react";
import { useSidebar } from "@/components/ui/sidebar";

const navItems = [
  { title: "Dashboard", icon: Home, path: "/dashboard" },
  { title: "Voorraad", icon: Database, path: "/inventory" },
  { title: "Meldingen", icon: Bell, path: "/notifications" },
  { title: "Orders", icon: ShoppingCart, path: "/orders" },
];

const MobileBottomNav = () => {
  const location = useLocation();
  const { setCollapsed } = useSidebar();

  return (
    <nav className="fixed bottom-0 left-0 right-0 z-50 bg-background border-t shadow-lg safe-area-bottom">
      <div className="flex items-center justify-around h-14">
        {navItems.map((item) => {
          const isActive = location.pathname === item.path;
          return (
            <Link
              key={item.path}
              to={item.path}
              className={`flex flex-col items-center justify-center flex-1 h-full min-w-[44px] min-h-[44px] transition-colors ${
                isActive
                  ? "text-primary"
                  : "text-muted-foreground"
              }`}
            >
              <item.icon className={`h-5 w-5 ${isActive ? "stroke-[2.5]" : ""}`} />
              <span className="text-[10px] mt-0.5 font-medium">{item.title}</span>
            </Link>
          );
        })}
        <button
          onClick={() => setCollapsed(false)}
          className="flex flex-col items-center justify-center flex-1 h-full min-w-[44px] min-h-[44px] text-muted-foreground transition-colors"
        >
          <Menu className="h-5 w-5" />
          <span className="text-[10px] mt-0.5 font-medium">Meer</span>
        </button>
      </div>
    </nav>
  );
};

export default MobileBottomNav;
